import React from 'react';
import { Icon } from 'semantic-ui-react';

export const Button = ({
  show,
  className,
  direction,
  style,
  onClick,
  handleClick,
}) => show && (
  <button
    className={`${direction} ${className}`}
    style={{ ...style }}
    onClick={() => {
      onClick();
      handleClick && handleClick();
    }}
  >
    <Icon name={`chevron ${direction}`} />
  </button>
);



// WEBPACK FOOTER //
// ./src/components/Button/Button.js